var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.load),expression:"load"}],attrs:{"indeterminate":"","color":"red darken-3"}})}
var staticRenderFns = []

export { render, staticRenderFns }